/**
 * Per-yard firefly group state — survives Friends switching within a session.
 */

import {
  createFireflyGroup,
  type FireflyGroupState,
} from '@/world-prototype/ambience/fireflyBehavior';
import type { FireflyYardConfig } from '@/world-prototype/ambience/fireflyYards';

/** Soft glow point diameter as a fraction of world width. */
export const FIREFLY_GLOW_BASE_FRAC = 0.0041;

/** Clamp glow size in CSS pixels for readability across layouts. */
export const FIREFLY_GLOW_MIN_PX = 5;
export const FIREFLY_GLOW_MAX_PX = 11;

const yardStates = new Map<string, FireflyGroupState>();

export function fireflyGroupForYard(
  yardId: string,
  config: FireflyYardConfig,
): FireflyGroupState {
  let state = yardStates.get(yardId);
  if (!state) {
    state = createFireflyGroup(config);
    yardStates.set(yardId, state);
  }
  return state;
}

export function clearFireflyGroupForYard(yardId: string): void {
  yardStates.delete(yardId);
}

export function resetFireflyStatesForTests(): void {
  yardStates.clear();
}
